import classNames from 'classnames'
import { forwardRef, HTMLAttributes } from 'react'

import styles from './table-body.module.scss'

export type TableBodyElement = HTMLTableSectionElement

export type TableBodyProps = HTMLAttributes<TableBodyElement>

const TableBody = forwardRef<TableBodyElement, TableBodyProps>(function TableBody(props, ref) {
  const { className, ...rest } = props
  const classes = classNames(styles.root, className)
  return <tbody {...rest} className={classes} ref={ref} />
})

export default TableBody
